import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Card = ({ children, className }) => {
    return <div className={classNames('card', className)}>{children}</div>;
};

Card.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export const CardHeader = ({ children, className }) => {
    return <header className={classNames('card-header', className)}>{children}</header>;
};

CardHeader.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export const CardBody = ({ children, className }) => {
    return <div className={classNames('card-content', className)}>{children}</div>;
};

CardBody.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export const CardFooter = ({ children, className }) => {
    return <footer className={classNames('card-footer', className)}>{children}</footer>;
};


CardFooter.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export const CardImg = ({ src, alt, className }) => {
    return <img className={classNames('card-image', className)} src={src} alt={alt} />;
};

CardImg.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
};

export const CardText = ({ children, className }) => {
    return <div className={classNames('content', className)}>{children}</div>;
};

CardText.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.Img = CardImg;
Card.Text = CardText;

export default Card;
